<template>
  <div class="max-w-[326px] w-full hidden lg:block">
    <slot />
  </div>
</template>
